(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SEL = '[data-ugc-wall]';

  function initWall(root) {
    if (root.dataset.ugcReady) return;
    root.dataset.ugcReady = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay !== 'false' && !reduce;
    // Hover-to-play on mouse devices (used when autoplay is off). Touch
    // devices get posters only; tapping opens the lightbox with sound.
    var hoverPlay = !autoplay && !reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ugc-wall__card'));
    var lightbox = root.querySelector('[data-ugc-lightbox]');
    var lbVideo = lightbox ? lightbox.querySelector('.ugc-lightbox__video') : null;
    var soundBtn = lightbox ? lightbox.querySelector('[data-ugc-sound]') : null;

    // --- Lazy load + autoplay/pause on scroll ---
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target.querySelector('.ugc-wall__video');
        if (!v) return;
        if (entry.isIntersecting) {
          if (!v.getAttribute('src') && v.dataset.src) {
            v.setAttribute('src', v.dataset.src);
            v.load();
          }
          if (autoplay) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.5 });

    cards.forEach(function (card) {
      io.observe(card);
      var btn = card.querySelector('.ugc-wall__media');
      if (btn) {
        btn.addEventListener('click', function () { openLightbox(card); });
      }
      if (hoverPlay) {
        card.addEventListener('mouseenter', function () {
          var v = card.querySelector('.ugc-wall__video');
          if (!v) return;
          if (!v.getAttribute('src') && v.dataset.src) {
            v.setAttribute('src', v.dataset.src);
            v.load();
          }
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
        card.addEventListener('mouseleave', function () {
          var v = card.querySelector('.ugc-wall__video');
          if (v && !v.paused) v.pause();
        });
      }
    });

    // --- Lightbox ---
    function openLightbox(card) {
      if (!lightbox || !lbVideo) return;
      var v = card.querySelector('.ugc-wall__video');
      var full = v ? (v.dataset.full || v.dataset.src) : '';
      var poster = v ? (v.dataset.poster || v.getAttribute('poster') || '') : '';
      if (!full) return;

      // pause the inline card video while the lightbox is open
      if (v && !v.paused) v.pause();

      if (poster) lbVideo.setAttribute('poster', poster);
      var tk = lightbox.querySelector('[data-ugc-tiktok]');
      if (tk) {
        var tkUrl = v ? (v.dataset.tiktok || '') : '';
        tk.hidden = !tkUrl;
        if (tkUrl) tk.href = tkUrl;
      }
      lbVideo.src = full;
      lbVideo.currentTime = 0;
      lbVideo.muted = false;
      setSoundLabel(false);
      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      var p = lbVideo.play();
      if (p && p.catch) {
        p.catch(function () {
          // Autoplay-with-sound blocked: fall back to muted playback
          lbVideo.muted = true;
          setSoundLabel(true);
          var p2 = lbVideo.play();
          if (p2 && p2.catch) p2.catch(function () {});
        });
      }
      lastFocus = document.activeElement;
      var closeBtn = lightbox.querySelector('.ugc-lightbox__btn--close');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lbVideo.pause();
      lbVideo.removeAttribute('src');
      lbVideo.load();
      lightbox.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function setSoundLabel(muted) {
      if (!soundBtn) return;
      soundBtn.textContent = muted ? 'Sound off' : 'Sound on';
      soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    }

    var lastFocus = null;

    if (lightbox) {
      lightbox.querySelectorAll('[data-ugc-close]').forEach(function (el) {
        el.addEventListener('click', closeLightbox);
      });
      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          lbVideo.muted = !lbVideo.muted;
          setSoundLabel(lbVideo.muted);
          if (!lbVideo.muted) {
            var p = lbVideo.play();
            if (p && p.catch) p.catch(function () {});
          }
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
      });
    }
  }

  function initAll() {
    document.querySelectorAll(SEL).forEach(initWall);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  // Theme editor: re-init when a section is reloaded
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
